// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"57e9b7186d60420dd35d","293":"5ddaca64c1620fc63fb8"}[chunkId] + ".js";
};